import {
  BarComponent,
  CardContainer,
} from "components/VatReturn";
import React from "react";
import styles from "../../components/VatReturn/VatReturn.module.scss";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";
import { useState, useEffect } from "react";
import VatReturnTab from "./VatReturnTab";
import * as api from "../../api/index";
import { Button } from "@progress/kendo-react-buttons";

const VatDetails = (props) => {
  const [tabs] = useState([
    "VAT Return",
    "Transactions by VAT box",
    "Transactions by tax rate",
  ]);
  const [selected, setSelected] = React.useState(0);
  const [calculationData, setCalculationData] = useState({});

  const handleSelect = (e) => setSelected(e.selected);

  const getVatReturnData = async () => {
    try {
      const data = await api.getVatReturnData(
        props.item.fromDate,
        props.item.toDate
      );
      setCalculationData(data?.data?.data?.calculations);
    } catch (error) { }
  };

  useEffect(() => {
    getVatReturnData();
  }, [props.item]);

  return (
    <CardContainer>
      <div className={`container-fluid companytab ${styles["vat-tab-wrapper"]} px-3 py-2`}>
        <TabStrip
          keepTabsMounted={true}
          selected={selected}
          onSelect={handleSelect}
          className="mt-1 pagetab companytab"
        >
          {tabs.map((item, index) => (
            <TabStripTab
              key={index}
              title={
                <PageTabItemTitle
                  title={item}
                  index={tabs.indexOf(item)}
                  selected={selected}
                />
              }
            >
              <div className={styles["company-tabs"]}>
                {item === "VAT Return" && (
                  <VatReturnTab
                    data={calculationData}
                    onBack={props.onBack}
                    item={props.item}
                  />
                )}
              </div>
            </TabStripTab>
          ))}
        </TabStrip>
      </div>

      <div className={styles["vat-footer"]}>
        <BarComponent />
        <div className="d-flex justify-content-between align-items-center ps-3 pe-3 pt-2 pb-2">
          <p className="mb-0">
            <u>Apply Postponed VAT Accounting (PVA) Adjustments</u>
          </p>
          <Button className="common-btn me-1">Submit to HMRC</Button>
        </div>
      </div>
    </CardContainer>
  );
};

export default VatDetails;
